/**
 * @internal
 */
export const WorkflowCommands = {
  /** Special command: 'all' is a catch-all for workflows that should run on every command */
  all: 'all',

  /** Special Command: 'refresh' is usually run inside other commands after execution */
  refresh: 'refresh',
};
